import {
  getMemberErrorMessage,
  MEMBER_ERROR_MESSAGES,
} from '@shared/member-errors';
import type { Member } from '@shared/api.interface';
import { getCycleDateRange } from './cycle-dates';

export { MEMBER_ERROR_MESSAGES, getMemberErrorMessage };

export function extractMemberErrorMessage(
  error: unknown,
  fallback = MEMBER_ERROR_MESSAGES.SERVICE_ERROR,
): string {
  const data = (error as any)?.response?.data;
  const code = data?.error?.code || data?.code || data?.error_code;
  return getMemberErrorMessage(typeof code === 'string' ? code : undefined, fallback);
}

/**
 * 周期/总额度用完时的提示文案（按额度类型区分）。
 * - 按月配额：说明下个周期自动恢复的具体日期（复用会员权益的“下次恢复”计算）。
 * - 总额度：不会自动恢复，需准确说明，而不是一律“请联系客服续费”。
 */
export function getQuotaExhaustedMessage(member: Member): string {
  if (member.quota_mode === 'total') {
    return '总次数已用完，不会自动恢复，如需继续领取请联系客服续费';
  }
  const cycleDates = getCycleDateRange(member.cycle_start_date);
  return cycleDates?.nextResetDate
    ? `本周期次数已用完，${cycleDates.nextResetDate} 自动恢复`
    : '本周期次数已用完，下个周期自动恢复';
}
